import { Text } from '@cko/primitives';
import styled from 'styled-components';
export const InlineText = styled(Text).attrs({
    as: 'div',
}) `
  &,
  > p,
  > span {
    font-weight: 500;
    color: var(--base-text-secondary);
  }
`;
